/**
 * 商品
 */

// 商品状态
// export const sellStatusOptions = [
//     {
//         label: '正常',
//         value: 1,
//     },
//     {
//         label: '暂时停购',
//         value: 3,
//     },
//     {
//         label: '季节停购',
//         value: 4,
//     },
//     {
//         label: '停止销售',
//         value: 2,
//     },
//     {
//         label: '清理中',
//         value: 5,
//     },
//     {
//         label: '新建档',
//         value: 9,
//     },
// ];
export const sellLevelOptions = [
    {
        label: '全部',
        value: -1,
    },
    {
        label: '高销',
        value: 1,
    },
];

export const sellStatusEnum = {
    /** 正常 */
    NORMAL: 1,
    /** 暂时停购 */
    TEMP_PAUSE: 3,
    /** 季节停购 */
    SEASON_PAUSE: 4,
    /** 停止销售 */
    STOP_SELL: 2,
    /** 清理中 */
    CLEANING: 5,
    /** 新建档 */
    NEW: 9,
};

// export const sellStatusMap = {
//     1: '正常',
//     3: '暂时停购',
//     4: '季节停购',
//     2: '停止销售',
//     5: '清理中',
//     9: '新建档',
// };

// 商品状态流转map
// export const statusFlowMap = {
//     9: [1],
//     1: [2, 3, 4, 5],
//     3: [1, 5],
//     4: [1, 5],
//     2: [1, 5],
//     5: [1],
// };

// 加工状态
// export const skuTypeOptions = [
//     {
//         label: '成品',
//         value: 1,
//     },
//     {
//         label: '原料',
//         value: 2,
//     },
//     {
//         label: '加工品',
//         value: 3,
//     },
// ];

// export const skuTypeMap = {
//     1: '成品',
//     2: '原料',
//     3: '加工品',
// };

// export const skuTypeEnum = {
//     /** 成品 */
//     END_PRODUCT: 1,
//     /** 原料 */
//     RAW_MATERIAL: 2,
//     /** 加工品 */
//     MADE_PRODUCT: 3,
// };

// 商品形态, 标品、散装
// export const packageTypeOptions = [
//     {
//         label: '标品',
//         value: 1,
//     },
//     {
//         label: '散装',
//         value: 2,
//     },
// ];

// export const packageTypeMap = {
//     1: '标品',
//     2: '散装',
// };

// export const packageTypeEnum = {
//     /** 标品 */
//     STANDARD: 1,
//     /** 散装 */
//     LOOSE: 2,
// };

// 修改商品状态和预留库存时备注原因
// export const remarkTypeEnum = {
//     COMMON: 1,
//     RESERVE_STOCK_UPDATE_PROD: 2,
//     SKU_STATUS_CLEANING: 3,
//     SKU_STATUS_STOP_SELL: 4,
// };

//
// export const skuBaseCodeTypeOptions = [
//     {
//         label: '标准条码',
//         value: 1,
//     },
//     {
//         label: '自编条码',
//         value: 2,
//     },
// ];

// export const skuBaseCodeTypeEnum = {
//     NOMALCODE: 1,
//     AUTOCODE: 2,
// };

// export const skuBaseCodeTypeMap = {
//     1: '标准条码',
//     2: '自编条码',
// };

// export const canSplitSellOptions = [{
//     label: '是(可切割售卖, 如烧鹅)',
//     value: true,
// }, {
//     label: '否',
//     value: false,
// }];

// export const canSplitSellMap = {
//     true: '是(可切割售卖, 如烧鹅)',
//     false: '否',
// };

export const operatePicTypeEnum = {
    LB_TYPE: 0,
    ZT_TYPE: 1,
    WM_TYPE: 2,
    VIDEO_TYPE: 3,
    DLB_TYPE: 4,
};

export const operatePicInfo = {
    NOMAL_HEIGHT: 750,
    NOMAL_WIDTH: 750,
    WM_HEIGHT: 750,
    WM_WIDTH: 750,
    DLB_HEIGHT: 304,
    DLB_WIDTH: 304,
    DLB_MAXSIZE: 1024,
    NOMAL_MAXSIZE: 300,
    ZT_MAXSIZE: 500,
    VIDEO_MAXSIZE: 80,
    MAX_PIXE_SIZE: 30,
};


// export const PAS = {
//     PENDING: 2, // 待审核
//     ALL: -1, // 全部
//     PASS: 4, // 审核通过
//     FAIL: 3, // 审核不通过
//     INIT: 0, // 初始化
// };

// 类目状态
export const categoryStatusMap = Object.freeze({
    PENDING: 1, // 待启用
    BECOME_EFFECTIVE: 2, // 已启用
    AWAITING_DISPOSAL: 3, // 待废弃
    ABANDONED: 4, // 已废弃
});
